import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'

import Hero from '../components/hero'
import Navbar from '../components/navbar'
import Calculator from '../components/calculator'
import Features from '../components/features'
import PreQualifying from '../components/pre-qualifying'
import Card from '../components/card'
import Stats3 from '../components/stats3'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>Help Me Out - Financial Support When You Need It Most</title>
        <meta property="og:title" content="Help Me Out - Financial Support When You Need It Most" />
        <link rel="canonical" href="https://www.helpmeout.co.za/" />
        <meta property="og:url" content="https://www.helpmeout.co.za/" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap" rel="stylesheet" />
      </Helmet>

      <Hero rootClassName="home-hero" />
      <Navbar />
      <Stats3
        heading1={<Fragment><span>Built for South Africans</span></Fragment>}
        content1={<Fragment><span>Fast, flexible financial support — when you need it most.</span></Fragment>}
        stat1={<Fragment><span>99%</span></Fragment>}
        stat1Description={<Fragment><span>Customer satisfaction</span></Fragment>}
        stat2={<Fragment><span>&lt; 5 min</span></Fragment>}
        stat2Description={<Fragment><span>Approval time</span></Fragment>}
        stat3={<Fragment><span>R8 000</span></Fragment>}
        stat3Description={<Fragment><span>Max loan amount</span></Fragment>}
        stat4={<Fragment><span>6 months</span></Fragment>}
        stat4Description={<Fragment><span>Flexible repayment</span></Fragment>}
      />
      <Calculator rootClassName="home-calculator" />
      <Features rootClassName="home-features" />
      <PreQualifying rootClassName="home-pre-qualifying" />
      <Card rootClassName="home-card" />

      <Footer
        text={<Fragment><span className="home-text24">Authorized Financial Credit Provider</span></Fragment>}
        text1={<Fragment><span className="home-text25">Our Partner In Business Funding</span></Fragment>}
        content1={<Fragment><span className="home-text26">Apply now for instant financial assistance.</span></Fragment>}
        content2={<Fragment><span className="home-text27">Get financial support when you need it most with HelpMeOut.</span></Fragment>}
        copyright={<Fragment><span className="home-text28">© {new Date().getFullYear()} HelpMeOut. All rights reserved.</span></Fragment>}
        termsLink={<Fragment><span className="home-text29">Terms of Use</span></Fragment>}
        cookiesLink={<Fragment><span className="home-text30">Cookies</span></Fragment>}
        privacyLink={<Fragment><span className="home-text31">Privacy Policy</span></Fragment>}
      />
    </div>
  )
}

export default Home
